type LandscapeWrapperProps = {
	message?: string;
};
export const LandscapeWrapper = ({ message }: LandscapeWrapperProps) => (
	<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 text-white">
		<div className="flex max-w-md flex-col items-center gap-4 text-center">
			<div className="size-24 rounded-full border-4 border-white/30 bg-white/10" />
			<p className="font-semibold text-xl">Gire o dispositivo</p>
			<p className="text-sm text-white/80">
				{message ??
					"Para capturar e editar a foto, use o aparelho na orientação horizontal."}
			</p>
		</div>
	</div>
);
